import React, {useState, useRef} from 'react'
import {IconButton} from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import CloseIcon from '@material-ui/icons/Close'
import FilterListIcon from '@material-ui/icons/FilterList'

import './GanttFilters'
import SettingIcon from '../../../common/Icons/SettingIcon'
import SortingModal from './SortingModal/SortingModal'

const GanttFilters = ({filterAnchor, setFilterAnchor, setQuery, query, filters, setFilters}) => {
  const [elSort, setElSort] = useState(null)
  const refSearch = useRef(null)
  const [q, setQ] = useState(query)
  const filtersRef = useRef(null)

  const handleClickSortingButton = e => {
    setElSort(e.currentTarget)
  }

  const handleSubmit = e => {
    e.preventDefault()
    setQuery(q)
    if (refSearch.current) {
      refSearch.current.focus()
    }
  }

  return (
    <>
      <div className="ap-flex ap-flex--align-center">
        <form style={{display: 'flex'}} onSubmit={handleSubmit}>
          <IconButton type="submit" size="small" className="ap-icon-button ap-icon-button--svg">
            <SearchIcon />
          </IconButton>
          <input
            ref={refSearch}
            className="ap-typography"
            style={{width: 78, border: 'none'}}
            value={q}
            onChange={e => setQ(e.target.value)}
          />
        </form>
        <div ref={filtersRef} className="ap-flex ap-flex--end ap-gutter">
          {filterAnchor ? (
            <IconButton
              onClick={e => setFilterAnchor(e.currentTarget)}
              size="small"
              className="ap-icon-button ap-icon-button--svg"
              style={{
                border: '1.5px solid #3473ff',
                borderRadius: 18.5,
                color: '#3473ff',
                backgroundColor: `${filters.length ? '' : ''}`,
              }}
            >
              <FilterListIcon />
              <span className="ap-typography ap-typography--sm" style={{color: '#3473ff'}}>
                Filter
              </span>
            </IconButton>
          ) : !filters.length ? (
            <IconButton
              onClick={e => setFilterAnchor(filtersRef.current)}
              size="small"
              className="ap-icon-button ap-icon-button--svg"
            >
              <FilterListIcon />
            </IconButton>
          ) : (
            <div
              style={{
                width: 65,
                borderRadius: 18.5,
                color: '#3473ff',
                backgroundColor: `#dfe8fe`,
              }}
            >
              <IconButton
                onClick={e => setFilterAnchor(e.currentTarget)}
                size="small"
                className="ap-icon-button ap-icon-button--svg"
                style={{
                  color: '#3473ff',
                }}
              >
                <FilterListIcon />
              </IconButton>
              <span className="ap-typography ap-typography--sm" style={{color: '#3473ff'}}>
                |
              </span>
              <IconButton
                onClick={e => setFilters([])}
                size="small"
                className="ap-icon-button ap-icon-button--svg"
                style={{
                  color: '#3473ff',
                }}
              >
                <CloseIcon />
              </IconButton>
            </div>
          )}
          <IconButton
            onClick={handleClickSortingButton}
            size="small"
            className="ap-icon-button ap-icon-button--svg"
          >
            <SettingIcon />
          </IconButton>
        </div>
      </div>

      <SortingModal open={!!elSort} anchorEl={elSort} onClose={() => setElSort(null)} />
    </>
  )
}

export default GanttFilters
